import * as THREE from "three";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls.js";
//import { flattenJSON } from "three/src/animation/AnimationUtils";
import { RGBELoader } from "three/examples/jsm/loaders/RGBELoader.js";
import { FontLoader } from "three/examples/jsm/loaders/FontLoader.js";
import { TextGeometry } from "three/examples/jsm/geometries/TextGeometry.js";
/**
 * Background Audio
 */
// const audio = document.getElementById("backgroundMusic");
// audio.play(); // Play audio when the scene starts
// //Restart the song when it ends
// audio.addEventListener("ended", () => {
//   audio.currentTime = 0; // Set the playback time to 0 (start of the audio)
//   audio.play(); // Play the audio again
// });
//play audio when screen is clicked
// const audio = document.getElementById("backgroundMusic");
// // Function to play audio
// const playAudio = () => {
//   audio.play();
// };

// // Event listener for user interaction (e.g., click)
// document.addEventListener("click", playAudio);

// // Restart the song when it ends
// audio.addEventListener("ended", () => {
//   audio.currentTime = 0;
//   audio.play();
// });

//play audio when clicked once
const audio = document.getElementById("backgroundMusic");

// Function to play audio
const playAudio = () => {
  audio.play();
  // Remove the click event listener after the first interaction
  document.removeEventListener("click", playAudio);
};

// Event listener for user interaction (e.g., click)
document.addEventListener("click", playAudio);

// Restart the song when it ends
audio.addEventListener("ended", () => {
  audio.currentTime = 0;
  audio.play();
});


/**
 * Lights
 */
const pointLight = new THREE.PointLight("yellow", 100);
pointLight.position.set(0, 0, 3);
const pointLight2 = new THREE.PointLight("purple", 660);
pointLight2.position.set(0, -28, 0);
const pointLight3 = new THREE.PointLight("pink", 160);
pointLight3.position.set(0, 16, 0);
const light = new THREE.DirectionalLight("gold", 6);
light.position.set(0, 100, 0);
light.target.position.set(0, 50, 0);

/**
 * Base
 */
const canvas = document.querySelector("canvas.webgl"); // Canvas
const scene = new THREE.Scene(); // Scene
/**
 * Environment map
 */
const rgbeLoader = new RGBELoader();
rgbeLoader.load(
  "/textures/environmentMaps/kloofendal_48d_partly_cloudy_puresky_4k.hdr",
  (environmentMap) => {
    environmentMap.mapping = THREE.EquirectangularReflectionMapping;
    scene.background = environmentMap;
    scene.environment = environmentMap;
  }
);

//for textures stored in an object
const correctColorSpace = (colorSpaceObj) => {
  Object.values(colorSpaceObj).forEach((texture) => {
    texture.colorSpace = THREE.SRGBColorSpace;
  });
};
/**
 * Fonts/Text
 */
let textMesh; //set it globally in order to animate it later
const generatePhysicalFont = ({ fontLocation, text, size }) => {
  const fontLoader = new FontLoader();
  fontLoader.load(fontLocation, (font) => {
    const textGeometry = new TextGeometry(text, {
      font: font,
      size: size,
      height: 0.2,
      curveSegments: 12,
      bevelEnabled: true,
      bevelThickness: 0.03,
      bevelSize: 0.02,
      bevelOffset: 0,
      bevelSegments: 5,
    });
    const textMaterial = new THREE.MeshPhysicalMaterial();
    // Transmission
    textMaterial.transmission = 0.5;
    textMaterial.ior = 1.5;
    textMaterial.thickness = 0.1;
    textGeometry.center();
    //textMesh setup
    textMesh = new THREE.Mesh(textGeometry, textMaterial); //textMesh already declared globally
    textMesh.position.set(0, 39, -28);
    scene.add(textMesh);
    animateText();
    // Add event listener for mouse clicks on textMesh
    window.addEventListener("click", onMouseClick);
    // window.addEventListener("mousemove", onMouseMove);
  });
};

generatePhysicalFont({
  fontLocation: "/fonts/Early_GameBoy_Regular.json",
  text: "Music by : Chantress Seba",
  size: 1.5,
});
/**
 * Textures
 */
const textureObject = {};
const textureInfo = [
  { name: "nyameDuaTexture", location: "./textures/spaceGold/nyameDua.jpg" },
  { name: "flyTexture", location: "./textures/spaceGold/fly.jpg" },
  { name: "webTexture", location: "./textures/spaceGold/web.jpg" },
  { name: "orbTexture", location: "./textures/spaceGold/orb.jpg" },
  { name: "goldTexture", location: "./textures/spaceGold/gold.jpg" },
];
const loadTextures = (textureLoadInfo) => {
  const textureLoader = new THREE.TextureLoader();
  textureLoadInfo.forEach((obj) => {
    textureObject[obj.name] = textureLoader.load(obj.location);
  });
};
//load the textures & create new object
loadTextures(textureInfo);
correctColorSpace(textureObject);

const { nyameDuaTexture, flyTexture, webTexture, orbTexture, goldTexture } =
  textureObject;

//flyTexture
flyTexture.rotation = Math.PI;
flyTexture.offset.set(0, -0.5);
flyTexture.repeat.set(4, 2);
//orbTexture
orbTexture.offset.set(0.25, 0);
//repeatedMirrorWrapping
[flyTexture, orbTexture].forEach((texture) => {
  texture.wrapS = THREE.MirroredRepeatWrapping;
  texture.wrapT = THREE.MirroredRepeatWrapping;
});
/**
 * Object Geometries
 */
const boxGeometry = new THREE.BoxGeometry(1, 1, 1);
const sphereGeometry = new THREE.SphereGeometry(1, 32, 32);
const torusGeometry = new THREE.TorusGeometry(0.8, 0.25, 32, 96);
const orbitGeometry = new THREE.TorusGeometry(1.3, 0.004, 32, 96);
const bigTorusGeometry = new THREE.TorusGeometry(4, 0.15, 32, 96);
const coneGeometry = new THREE.ConeGeometry(1, 1, 32);
const cylinderGeometry = new THREE.CylinderGeometry(0.9, 0.5, 3.5, 32);
/**
 * MeshPhysicalMaterial
 */
//Create & Texturize physical material
const createPhysicalMeshMaterial = (texture) => {
  const material = new THREE.MeshPhysicalMaterial();
  material.map = texture;
  return material;
};
const nyameDuaMaterial = createPhysicalMeshMaterial(nyameDuaTexture);
const butterflyMaterial = createPhysicalMeshMaterial(flyTexture);
const webMaterial = createPhysicalMeshMaterial(webTexture);
const orbMaterial = createPhysicalMeshMaterial(orbTexture);
const goldMaterial = createPhysicalMeshMaterial(goldTexture);
//Alter physicalMaterial properties
[nyameDuaMaterial, butterflyMaterial, webMaterial, orbMaterial].forEach(
  (material) => {
    // Iridescence
    material.iridescence = 6;
    material.iridescenceIOR = 1;
    material.iridescenceThicknessRange = [100, 800];
    //metalness
    material.metalness = 0.7;
    material.roughness = 0;
    // Transmission
    material.transmission = 0.5;
    material.ior = 1.5;
    material.thickness = 0.1;
  }
);
//const topSphere = new THREE.Mesh(sphereGeometry, nyameDuaMaterial);
//const headRingVert = new THREE.Mesh(bigTorusGeometry, nyameDuaMaterial);
const flatCube = new THREE.Mesh(boxGeometry, webMaterial);
const sphere = new THREE.Mesh(sphereGeometry, nyameDuaMaterial);
const orb = new THREE.Mesh(sphereGeometry, orbMaterial);
const flatOrb = new THREE.Mesh(sphereGeometry, butterflyMaterial);
const orbit = new THREE.Mesh(orbitGeometry, goldMaterial);
const torus = new THREE.Mesh(torusGeometry, nyameDuaMaterial);
const headRing = new THREE.Mesh(bigTorusGeometry, nyameDuaMaterial);
const cone = new THREE.Mesh(coneGeometry, nyameDuaMaterial);
const cylinder = new THREE.Mesh(cylinderGeometry, nyameDuaMaterial);

flatCube.scale.set(14, 14, 0.5);
/**
 * Cloning
 */
const midSection = orb.clone(true);
const [topSphere, bottom] = Array.from({ length: 2 }, () => sphere.clone(true));
const [rightEye, leftEye, coneEye] = Array.from({ length: 3 }, () =>
  torus.clone(true)
);
const [headRingVert, neckRing] = Array.from({ length: 2 }, () =>
  headRing.clone(true)
);
// const bodyTorus = headRing.clone(true);
const [flatGlobe, flatGlobe3, flatGlobe4] = Array.from({ length: 3 }, () =>
  flatOrb.clone(true)
);
const [vertCone, vertConeB] = Array.from({ length: 2 }, () => cone.clone(true));
orbit.scale.set(30, 30, 10);
orbit.rotation.x = 1.5;
orbit.position.y = -5.5;
const [orbit2, orbit3, orbit4, orbit5, orbit6, orbit7, orbit8] = Array.from(
  { length: 7 },
  () => orbit.clone(true)
);
const [
  rectBottom,
  rectTop,
  rectLeftTop,
  rectRightTop,
  rectLeftBottom,
  rectRightBottom,
] = Array.from({ length: 6 }, () => flatCube.clone(true));

/**
 * Positioning, Rotation, Scale
 */
cylinder.position.set(0, -6, -9.9);
cylinder.rotation.y = Math.PI;
neckRing.position.set(0, -6.1, -9.9);
neckRing.rotation.x = 1.5;
neckRing.scale.set(0.6, 0.6, 0.9);
midSection.position.set(0, -14.7, 0);
midSection.scale.set(3.7, 5.4, 4);
coneEye.position.set(0, 1.5, 2);
coneEye.scale.set(0.3, 0.2, 0.2);
coneEye.rotation.x = Math.PI * 0.5;
sphere.position.set(0, 0, 0);
sphere.scale.set(2.3, 5, 3);
sphere.rotation.y = -Math.PI * 0.5;
headRing.rotation.x = 1.5;

[flatGlobe, flatGlobe3, flatGlobe4].forEach((globe) => {
  globe.position.set(
    globe === flatGlobe3 ? -4.7 : globe === flatGlobe4 ? 4.7 : 0,
    globe === flatGlobe ? -8.2 : -21.5,
    0
  );
  globe.scale.set(
    globe === flatGlobe ? 9 : 4.5,
    globe === flatGlobe ? 0.9 : 0.6,
    globe === flatGlobe ? 4.5 : 2.5
  );
});

// bodyTorus.position.set(0, -15, 0);
// bodyTorus.rotation.x = Math.PI*0.5;
//bodyTorus.scale.set(1,1,1)
const rectangles = [rectBottom, rectTop, rectLeftTop, rectRightTop];
rectangles.forEach((rect) => {
  rect.rotation.x = rect === rectBottom || rect === rectTop ? 1.5 : 3; //top&Bottom =1.5 else=3
  rect.position.set(
    rect === rectLeftTop ? -13 : rect === rectRightTop ? 13 : 0, //x
    rect === rectTop ? 10 : rect === rectBottom ? -24 : 2.5, //y
    0 //z
  );
});
[rectLeftBottom, rectRightBottom].forEach((rect) => {
  rect.rotation.x = 1.5;
  rect.rotation.y = rect === rectLeftBottom ? -Math.PI * 0.25 : Math.PI * 0.25;
  rect.position.set(rect === rectLeftBottom ? -14 : 14, -13, 0);
});

const eyes = [rightEye, leftEye];
eyes.forEach((eye, index) => {
  eye.position.set(index === 0 ? 1.05 : -1.05, 5, -6);
});

const cones = [cone, vertCone, vertConeB];
cones.forEach((item) => {
  item.scale.set(0.5, 0.5, 0.5);
  item.position.set(
    item === vertCone ? -3 : 0,
    item === cone ? 1 : 0,
    item === cone ? 4 : item === vertCone ? 5.5 : 4.85
  );
  item.rotation.x =
    item === cone ? 0 : item === vertCone ? Math.PI * 0.5 : -Math.PI * 0.5;
});

const spaceShips = [topSphere, bottom];
spaceShips.forEach((ship) => {
  ship.scale.set(1.5, 19, 19);
  ship.rotation.z = Math.PI * 0.5;
  ship.position.set(0, ship === topSphere ? 15 : -29, 0);
});

headRingVert.scale.set(0.88, 1.5, 1);
// headRingVert.position.y = 0.15

scene.add(
  light,
  light.target,
  pointLight,
  pointLight2,
  pointLight3,
  flatGlobe4,
  rectLeftBottom,
  rectRightBottom,
  vertCone,
  vertConeB,
  cylinder,
  sphere,
  headRing,
  neckRing,
  cone,
  headRingVert,
  topSphere,
  bottom,
  rightEye,
  leftEye,
  coneEye,
  flatGlobe,
  midSection,
  flatGlobe3,
  //bodyTorus,
  rectBottom,
  rectTop,
  rectLeftTop,
  rectRightTop,
  orbit,
  orbit2,
  orbit3,
  orbit4,
  orbit5,
  orbit6,
  orbit7,
  orbit8
);
// Sizes - use for window & camera sizes
const sizes = {
  width: window.innerWidth,
  height: window.innerHeight,
};

//resize sizes background/canvas whenever window size changes
window.addEventListener("resize", () => {
  // Update sizes
  sizes.width = window.innerWidth;
  sizes.height = window.innerHeight;
  // Update camera
  camera.aspect = sizes.width / sizes.height;
  camera.updateProjectionMatrix();
  // Update renderer
  renderer.setSize(sizes.width, sizes.height);
  renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
  // Set background color to white
  renderer.setClearColor(0xffffff);
});
// Camera
const camera = new THREE.PerspectiveCamera(
  75,
  sizes.width / sizes.height,
  0.1,
  1000
);
camera.position.z = 75;
scene.add(camera);
// Controls
const controls = new OrbitControls(camera, canvas);
controls.enableDamping = true;
// Renderer
const renderer = new THREE.WebGLRenderer({
  canvas: canvas,
});
renderer.setSize(sizes.width, sizes.height);
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
// Set background color to white
renderer.setClearColor(0xffffff);

/**
 * Flying Cubes in the Air
 */
let flyingTowardsCubes = [];
let flyingAwayCubes = [];

const cubeFlight = () => {
  for (let i = 0; i < 900; i++) {
    const flyCube = new THREE.Mesh(boxGeometry, nyameDuaMaterial);
    const secondFlyCube = new THREE.Mesh(boxGeometry, webMaterial);
    const scale = Math.random();
    [flyCube, secondFlyCube].forEach((cube) => {
      cube.scale.set(scale, scale, scale);
      cube.rotation.set(
        (Math.random() - 0.5) * 95,
        (Math.random() - 0.5) * 85,
        (Math.random() - 0.5) * 100
      );
      cube.position.set(
        (Math.random() - 0.5) * 185,
        (Math.random() - 0.5) * 135,
        cube === flyCube ? (Math.random() - 1) * 800 : Math.random() * 800
      );
    });
    flyingTowardsCubes.push(flyCube);
    flyingAwayCubes.push(secondFlyCube);
    scene.add(flyCube, secondFlyCube);
  }
};
cubeFlight();
//AnimateText
function animateText() {
  const elapsedTime = clock.getElapsedTime();
  textMesh.rotation.z = 0.05 * Math.sin(elapsedTime * 0.8);
  textMesh.rotation.y = 0.05 * Math.cos(elapsedTime * 0.8);
  requestAnimationFrame(animateText);
}
// Animate Main Objects
const clock = new THREE.Clock();
const animate = () => {
  const elapsedTime = clock.getElapsedTime();
  sphere.rotation.y += 0.003 * Math.sin(elapsedTime * 0.8);
  sphere.rotation.z += 0.002 * Math.cos(elapsedTime * 0.8);
  rightEye.rotation.x = -(0.1 * elapsedTime + 0.0001);
  leftEye.rotation.x = 0.1 * elapsedTime + 0.0001;
  headRingVert.rotation.y = 0.1 * elapsedTime + 0.0001;
  headRing.rotation.y = 0.1 * Math.sin(elapsedTime);
  neckRing.rotation.y = -headRing.rotation.y;
  rectBottom.rotation.z = 0.2 * elapsedTime + 0.0001;
  rectTop.rotation.z = -rectBottom.rotation.z;
  rectRightTop.rotation.y = 0.2 * elapsedTime + 0.0001;
  rectLeftTop.rotation.y = -rectRightTop.rotation.y;
  [rectLeftBottom, rectRightBottom].forEach((item) => {
    item.position.z =
      item === rectLeftBottom
        ? 11 * Math.sin(elapsedTime * 0.2)
        : -11 * Math.sin(elapsedTime * 0.2);
    item.rotation.y =
      item === rectLeftBottom
        ? 0.2 * -(elapsedTime + 0.0001)
        : 0.2 * elapsedTime + 0.0001;
  });
  cone.position.set(
    4 * Math.sin(elapsedTime * 0.2),
    1,
    4 * Math.cos(elapsedTime * 0.2)
  );
  cone.rotation.set(
    0,
    0.3 * Math.sin(elapsedTime),
    0.3 * Math.sin(elapsedTime)
  );
  vertCone.position.set(
    5.0 * Math.cos(elapsedTime * 0.105),
    0,
    4.5 * -Math.sin(elapsedTime * 0.105)
  );
  vertCone.rotation.set(
    1.5,
    0.3 * Math.sin(elapsedTime),
    0.3 * Math.sin(elapsedTime)
  );
  vertConeB.position.set(
    0,
    6.7 * Math.sin(elapsedTime * 0.2),
    5.9 * Math.cos(elapsedTime * 0.2)
  );
  vertConeB.rotation.set(
    -1.5,
    0.3 * Math.sin(elapsedTime),
    0.3 * Math.sin(elapsedTime)
  );
  cylinder.rotation.set(
    0.2 * Math.sin(elapsedTime),
    0.2 * Math.cos(elapsedTime),
    0
  );
  topSphere.rotation.set(
    0.2 * Math.cos(elapsedTime * 0.08),
    0.3 * Math.sin(elapsedTime * 0.8),
    Math.PI * 0.5
  );
  topSphere.position.set(
    4 * Math.sin(elapsedTime * 0.2),
    15,
    4 * Math.cos(elapsedTime * 0.2)
  );
  bottom.rotation.set(
    0.2 * Math.cos(elapsedTime * 0.08),
    0.3 * Math.sin(elapsedTime * 0.8),
    Math.PI * 0.5
  );
  bottom.position.set(
    4 * -Math.sin(elapsedTime * 0.2),
    -29,
    4 * -Math.cos(elapsedTime * 0.2)
  );
  midSection.rotation.y = 0.8 * Math.sin(0.1 * elapsedTime + 0.0001);
  flatGlobe.rotation.set(
    0,
    0.2 * elapsedTime + 0.0001,
    -(0.1 * Math.sin(elapsedTime * 0.8))
  );
  flatGlobe3.rotation.set(
    0,
    -(0.5 * Math.cos(elapsedTime * 0.8)),
    -(0.3 * Math.sin(elapsedTime * 0.8))
  );
  flatGlobe4.rotation.set(
    0,
    0.5 * Math.sin(elapsedTime * 0.8),
    0.3 * Math.cos(elapsedTime * 0.8)
  );
  coneEye.position.set(
    4 * Math.sin(elapsedTime * 0.2),
    1.5,
    4 * Math.cos(elapsedTime * 0.2)
  );

  coneEye.rotation.set(
    Math.PI * 0.5,
    0.3 * Math.sin(elapsedTime),
    0.3 * Math.sin(elapsedTime)
  );

  const orbitMotion = 0.08 * (elapsedTime + 0.0001);
  orbit.rotation.y = -orbitMotion;
  orbit2.rotation.y = orbitMotion;
  orbit3.rotation.x = orbitMotion;
  orbit4.rotation.x = -orbitMotion;
  orbit5.rotation.x = -orbitMotion;
  orbit5.rotation.y = -orbitMotion;
  orbit6.rotation.y = orbitMotion;
  orbit6.rotation.x = orbitMotion;
  orbit7.rotation.y = -orbitMotion;
  orbit7.rotation.x = orbitMotion;
  orbit8.rotation.y = orbitMotion;
  orbit8.rotation.x = -orbitMotion;

  // bodyTorus.rotation.y = 0.1 * Math.sin(elapsedTime);

  flyingTowardsCubes.forEach((item) => {
    item.rotation.z = (elapsedTime * 0.4) % (Math.PI * 2);
    item.rotation.y = (elapsedTime * 0.3) % (Math.PI * 2);
    item.position.z += 1.005 * Math.sin(elapsedTime * 0.00006);
    // Reset position after a certain threshold
    if (item.position.z > 1000) {
      item.position.z = (Math.random() - 1) * 800; // Set to the initial position
    }
  });

  flyingAwayCubes.forEach((item) => {
    item.rotation.z = elapsedTime * 0.4;
    item.rotation.y = elapsedTime * 0.3;
    item.position.z -= 1.005 * Math.sin(elapsedTime * 0.00006);
    if (item.position.z < -1000) {
      item.position.z = Math.random() * 800; // Set to the initial position
    }
  });

  // Update controls
  controls.update();
  // Render
  renderer.render(scene, camera);
  // Call animate again on the next frame
  window.requestAnimationFrame(animate);
};

function onMouseClick(event) {
  // Calculate normalized device coordinates (NDC)
  const mouse = new THREE.Vector2();
  mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
  mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;
  // Create a raycaster and check for intersections
  const raycaster = new THREE.Raycaster();
  raycaster.setFromCamera(mouse, camera);
  const intersects = raycaster.intersectObject(textMesh);
  // If the text is clicked, open the link
  if (intersects.length > 0) {
    window.open(
      "https://www.youtube.com/watch?v=UDXZs0dsPSA&ab_channel=ChantressSeba",
      "_blank"
    ); // Open link in a new tab/window
  }
}
animate();
